<template>
  <!-- *** -->
  <!-- Web -->
  <!-- *** -->
  <section class="section_web" id="web">
    <article class="section_web__article_top">
      <h1 class="section_web__article_top__h1">
        Web
      </h1>
    </article>
    <!-- Site vitrine -->
    <article class="section_web__article_left">
      <aside class="section_web__article_left__aside_top">
        <div class="section_web__article_left__aside_top__div">
          <h1 class="section_web__article_left__aside_top__div__h1">
            Site vitrine
          </h1>
        </div>
      </aside>
      <!--  -->
      <aside class="section_web__article_left__aside_middle">
        <div class="section_web__article_left__aside_middle__div_text">
          <p class="section_web__article_left__aside_middle__div_text__p">
            Site web parfait pour des CV numériques, portfolios etc. Sans base de données.
          </p>
        </div>
        <div class="section_web__article_left__aside_middle__div_img">
          <img src="@/assets/browser.png" alt="site vitrine"
            class="section_web__article_left__aside_middle__div_img__img">
        </div>
      </aside>
      <!--  -->
      <aside class="section_web__article_left__aside_bottom">
        <div class="section_web__article_left__aside_bottom__div">
          <button class="section_web__article_left__aside_bottom__div__button">
            <router-link class="section_web__article_left__aside_bottom__div__button__router-link" to="/site-vitrine">
              En savoir plus
            </router-link>
          </button>
        </div>
      </aside>
    </article>

    <!-- Application web -->
    <article class="section_web__article_middle">
      <aside class="section_web__article_middle__aside_top">
        <div class="section_web__article_middle__aside_top__div">
          <h1 class="section_web__article_middle__aside_top__div__h1">
            Application web
          </h1>
        </div>
      </aside>
      <!--  -->
      <aside class="section_web__article_middle__aside_middle">
        <div class="section_web__article_middle__aside_middle__div_text">
          <p class="section_web__article_middle__aside_middle__div_text__p">
            Pour un site web conséquent, avec divers fonctionnalités ainsi une gestion des visiteur. Avec base de
            données.
          </p>
        </div>
        <div class="section_web__article_middle__aside_middle__div_img">
          <img src="@/assets/commerce.jpg" alt="Application web" width="20rem"
            class="section_web__article_middle__aside_middle__div_img__img">
        </div>
      </aside>
      <!--  -->
      <aside class="section_web__article_middle__aside_bottom">
        <div class="section_web__article_middle__aside_bottom__div">
          <button class="section_web__article_middle__aside_bottom__div__button">
            <router-link class="section_web__article_middle__aside_bottom__div__button__router-link"
              to="/application-web">
              En savoir plus
            </router-link>
          </button>
        </div>
      </aside>
    </article>

    <!-- Site WordPress -->
    <article class="section_web__article_right">
      <aside class="section_web__article_right__aside_top">
        <div class="section_web__article_right__aside_top__div">
          <h1 class="section_web__article_right__aside_top__div__h1">
            Site Wordpress
          </h1>
        </div>
      </aside>
      <!--  -->
      <aside class="section_web__article_right__aside_middle">
        <div class="section_web__article_right__aside_middle__div_text">
          <p class="section_web__article_right__aside_middle__div_text__p">
            Site rapide avec Wordpress, possibilité d'entretenir le site par le client. Avec base de données.
          </p>
        </div>
        <div class="section_web__article_right__aside_middle__div_img">
          <img src="@/assets/digital.jpg" alt="Site Wordpress" width="20rem"
            class="section_web__article_right__aside_middle__div_img__img">
        </div>
      </aside>
      <!--  -->
      <aside class="section_web__article_right__aside_bottom">
        <div class="section_web__article_right__aside_bottom__div">
          <button class="section_web__article_right__aside_bottom__div__button">
            <router-link class="section_web__article_right__aside_bottom__div__button__router-link" to="/wordpress">
              En savoir plus
            </router-link>
          </button>
        </div>
      </aside>
    </article>
  </section>

  <!-- ******************** -->
  <!-- Mes valeur -->
  <!-- ******************** -->

  <section class="section_valeur">
    <div class="section_valeur__div">
      <h1 class="section_valeur__div__h1">
        Mes valeurs
      </h1>
    </div>
    <!--  -->
    <article class="section_valeur__article">
      <aside class="section_valeur__article__aside_1">
        <div class="section_valeur__article__aside_1__div">
          <p class="section_valeur__article__aside_1__div__p">
            Professionel
          </p>
        </div>
      </aside>
      <!--  -->
      <aside class="section_valeur__article__aside_2">
        <div class="section_valeur__article__aside_2__div">
          <p class="section_valeur__article__aside_2__div__p">
            Joignable
          </p>
        </div>
      </aside>
      <!--  -->
      <aside class="section_valeur__article__aside_3">
        <div class="section_valeur__article__aside_3__div">
          <p class="section_valeur__article__aside_3__div__p">
            Réactif
          </p>
        </div>
      </aside>
      <!--  -->
      <aside class="section_valeur__article__aside_4">
        <div class="section_valeur__article__aside_4__div">
          <p class="section_valeur__article__aside_4__div__p">
            À l'écoute
          </p>
        </div>
      </aside>
    </article>
  </section>

  <!-- ********** -->
  <!-- Industriel -->
  <!-- ********** -->

  <section class="section_industriel" id="industriel">
    <article class="section_industriel__article_top">
      <h1 class="section_industriel__article_top__h1">
        Industriel
      </h1>
    </article>
    <!-- Conception -->
    <article class="section_industriel__article_left">
      <aside class="section_industriel__article_left__aside_top">
        <div class="section_industriel__article_left__aside_top__div">
          <h1 class="section_industriel__article_left__aside_top__div__h1">
            Conception
          </h1>
        </div>
      </aside>
      <!--  -->
      <aside class="section_industriel__article_left__aside_middle">
        <div class="section_industriel__article_left__aside_middle__div_text">
          <p class="section_industriel__article_left__aside_middle__div_text__p">
            Conception de pièces ou d'ensemble mécanique plus complexe.
          </p>
        </div>
        <div class="section_industriel__article_left__aside_middle__div_img">
          <img src="@/assets/modification.jpg" alt="Coonception"
            class="section_industriel__article_left__aside_middle__div_img__img">
        </div>
      </aside>
      <!--  -->
      <aside class="section_industriel__article_left__aside_bottom">
        <div class="section_industriel__article_left__aside_bottom__div">
          <button class="section_industriel__article_left__aside_bottom__div__button">
            <router-link class="section_industriel__article_left__aside_bottom__div__button__router-link"
              to="/conception">
              En savoir plus
            </router-link>
          </button>
        </div>
      </aside>
    </article>

    <!-- Mise en plan -->
    <article class="section_industriel__article_middle">
      <aside class="section_industriel__article_middle__aside_top">
        <div class="section_industriel__article_middle__aside_top__div">
          <h1 class="section_industriel__article_middle__aside_top__div__h1">
            Mise en plan
          </h1>
        </div>
      </aside>
      <!--  -->
      <aside class="section_industriel__article_middle__aside_middle">
        <div class="section_industriel__article_middle__aside_middle__div_text">
          <p class="section_industriel__article_middle__aside_middle__div_text__p">
            Réalisation de plan technique de pièce simple ou plus complexe, ainsi que d'assemblage.
          </p>
        </div>
        <div class="section_industriel__article_middle__aside_middle__div_img">
          <img src="@/assets/infra-convert.jpg" alt="Mise en plan"
            class="section_industriel__article_middle__aside_middle__div_img__img">
        </div>
      </aside>
      <!--  -->
      <aside class="section_industriel__article_middle__aside_bottom">
        <div class="section_industriel__article_middle__aside_bottom__div">
          <button class="section_industriel__article_middle__aside_bottom__div__button">
            <router-link class="section_industriel__article_middle__aside_bottom__div__button__router-link"
              to="/mise-en-plan">
              En savoir plus
            </router-link>
          </button>
        </div>
      </aside>
    </article>

    <!-- Rendu réaliste -->

    <article class="section_industriel__article_right">
      <aside class="section_industriel__article_right__aside_top">
        <div class="section_industriel__article_right__aside_top__div">
          <h1 class="section_industriel__article_right__aside_top__div__h1">
            Rendu réaliste
          </h1>
        </div>
      </aside>
      <!--  -->
      <aside class="section_industriel__article_right__aside_middle">
        <div class="section_industriel__article_right__aside_middle__div_text">
          <p class="section_industriel__article_right__aside_middle__div_text__p">
            Création de rendu réaliste de vos assemblages ou de vos pièces. Une fois effectué, l'envoie du rendu
            s'effectue dans les plus brefs délais.
          </p>
        </div>
        <div class="section_industriel__article_right__aside_middle__div_img">
          <img src="@/assets/cropped-SW-Professional.jpg" alt="Rendu réaliste"
            class="section_industriel__article_right__aside_middle__div_img__img">
        </div>
      </aside>
      <!--  -->
      <aside class="section_industriel__article_right__aside_bottom">
        <div class="section_industriel__article_right__aside_bottom__div">
          <button class="section_industriel__article_right__aside_bottom__div__button">
            <router-link class="section_industriel__article_right__aside_bottom__div__button__router-link"
              to="/rendu-realiste">
              En savoir plus
            </router-link>
          </button>
        </div>
      </aside>
    </article>
  </section>

  <!-- ******************** -->
  <!-- Autres prestations -->
  <!-- ******************** -->

  <section class="section_prestations">
    <div class="section_prestations__div">
      <h1 class="section_prestations__div__h1">
        Autre prestations
      </h1>
      <!-- hovver -->
      <p class="section_prestations__div__p">
        Ces services sont éffectués par des partenaires de confiances.
      </p>
    </div>
    <article class="section_prestations__article">
      <aside class="section_prestations__article__aside_1">
        <div class="section_prestations__article__aside_1__div">
          <a href="" class="section_prestations__article__aside_1__div__a">
            Traduction
          </a>
        </div>
      </aside>
      <!--  -->
      <aside class="section_prestations__article__aside_2">
        <div class="section_prestations__article__aside_2__div">
          <a href="" class="section_prestations__article__aside_2__div__a">
            Juridique
          </a>
        </div>
      </aside>
      <!--  -->
      <aside class="section_prestations__article__aside_3">
        <div class="section_prestations__article__aside_3__div">
          <a href="https://www.anyouali.fr/" class="section_prestations__article__aside_3__div__a">
            Développeur web
          </a>
        </div>
      </aside>
      <!--  -->
      <aside class="section_prestations__article__aside_4">
        <div class="section_prestations__article__aside_4__div">
          <a class="section_prestations__article__aside_4__div__a">
            Autre
          </a>
        </div>
      </aside>
    </article>
  </section>

  <!-- *** -->
  <!-- Tir -->
  <!-- *** -->

  <section class="section_tir" id="tir">
    <article class="section_tir__article_top">
      <h1 class="section_tir__article_top__h1">
        Tir
      </h1>
    </article>
    <!-- Tir de combat -->
    <article class="section_tir__article_left">
      <aside class="section_tir__article_left__aside_top">
        <div class="section_tir__article_left__aside_top__div">
          <h1 class="section_tir__article_left__aside_top__div__h1">
            Tir de combat
          </h1>
        </div>
      </aside>
      <!--  -->
      <aside class="section_tir__article_left__aside_middle">
        <div class="section_tir__article_left__aside_middle__div_text">
          <p class="section_tir__article_left__aside_middle__div_text__p">
            Instruction aux manipulation avec une arme à feu, ainsi que drill.
          </p>
        </div>
        <div class="section_tir__article_left__aside_middle__div_img">
          <img src="@/assets/youth.jpg" alt="Tir de combat"
            class="section_tir__article_left__aside_middle__div_img__img">
        </div>
      </aside>
      <!--  -->
      <aside class="section_tir__article_left__aside_bottom">
        <div class="section_tir__article_left__aside_bottom__div">
          <button class="section_tir__article_left__aside_bottom__div__button">
            <router-link class="section_tir__article_left__aside_bottom__div__button__router-link" to="/istc">
              En savoir plus
            </router-link>
          </button>
        </div>
      </aside>
    </article>

    <!-- instructeur de tir -->
    <article class="section_tir__article_middle">
      <aside class="section_tir__article_middle__aside_top">
        <div class="section_tir__article_middle__aside_top__div">
          <h1 class="section_tir__article_middle__aside_top__div__h1">
            Instructeur de tir
          </h1>
        </div>
      </aside>
      <!--  -->
      <aside class="section_tir__article_middle__aside_middle">
        <div class="section_tir__article_middle__aside_middle__div_text">
          <p class="section_tir__article_middle__aside_middle__div_text__p">
            Application de l'instruction au tir de combat. Conseil et accompagnement personnalisé.
          </p>
        </div>
        <div class="section_tir__article_middle__aside_middle__div_img">
          <img src="@/assets/soldier.jpg" alt="Instructeur de tir"
            class="section_tir__article_middle__aside_middle__div_img__img">
        </div>
      </aside>
      <!--  -->
      <aside class="section_tir__article_middle__aside_bottom">
        <div class="section_tir__article_middle__aside_bottom__div">
          <button class="section_tir__article_middle__aside_bottom__div__button">
            <router-link class="section_tir__article_middle__aside_bottom__div__button__router-link" to="/instruction">
              En savoir plus
            </router-link>
          </button>
        </div>
      </aside>
    </article>

    <!-- Défense -->

    <article class="section_tir__article_right">
      <aside class="section_tir__article_right__aside_top">
        <div class="section_tir__article_right__aside_top__div">
          <h1 class="section_tir__article_right__aside_top__div__h1">
            Défense
          </h1>
        </div>
      </aside>
      <!--  -->
      <aside class="section_tir__article_right__aside_middle">
        <div class="section_tir__article_right__aside_middle__div_text">
          <p class="section_tir__article_right__aside_middle__div_text__p">
            Conseil, et apprentissage de technique d'autodéfense. Pour la défense du domicile ainsi que d'infrastructure
            plus complexes.
          </p>
        </div>
        <div class="section_tir__article_right__aside_middle__div_img">
          <img src="@/assets/child.jpg" alt="Défense" class="section_tir__article_right__aside_middle__div_img__img">
        </div>
      </aside>
      <!--  -->
      <aside class="section_tir__article_right__aside_bottom">
        <div class="section_tir__article_right__aside_bottom__div">
          <button class="section_tir__article_right__aside_bottom__div__button">
            <router-link class="section_tir__article_right__aside_bottom__div__button__router-link" to="/defense">
              En savoir plus
            </router-link>
          </button>
        </div>
      </aside>
    </article>
  </section>
</template>

<script >
export default {
  name: 'ServicesDesktop',
}
</script>

<style  lang=scss scoped>
@import "@/style/components/Services/ServicesDesktop.scss";

@media screen and(max-width: 926px) {
  .container {
    display: none;
  }
}
</style>